export const resources = {
  en: {
    translation: {
      //LOGIN PAGE
      //header
      'login-header': 'Welcome!',
      //login CTA
      'login-cta': 'Sign in to access our platform!',
      //login question
      'login-question': 'Don\'t have an account?',
      //login plans CTA
      'login-plans-cta': 'Click the button below to see our plans:',
      //login button
      'login-button-plans': 'SEE PLANS',
      //login e-mail field
      'login-email': 'e-mail',
      //login e-mail password
      'login-password': 'password',
      //login button access
      'login-button-access': 'SIGN IN',
      //login button forgot password
      'login-button-forgot-password': 'Forgot your password?',

      //GROUPS HEADER
      //group-welcome
      'group-welcome': 'Welcome',
      //group-intro
      'group-intro': 'You are logged in as',
      //group-admin
      'group-admin': 'Administrator!',
      //group-user
      'group-user': 'User!',
      //group-header
      'group-header': 'GROUPS',
      //group-button
      'group-button': 'NEW GROUP',

      //GROUPS LIST
      //group-list-header
      'group-list-header': 'View Groups',
      //group-list-title
      'group-list-intro': 'PROJECTS',
      //group-list-button
      'group-list-button': 'NEW PROJECT',
      //group-searchbar
      'group-searchbar': 'Search here...',
      //group-no-projects
      'group-no-projects': 'This group does not have any projects! 😢 ',

      //GROUPS TABLE ITEMS
      //group-table-title
      'group-table-title': 'TITLE',
      //group-table-description
      'group-table-description': 'DESCRIPTION',
      //group-table-manager
      'group-table-manager': 'MANAGER',
      //group-table-actions
      'group-table-actions': 'ACTIONS',
      //group-table-action-download
      'group-table-action-download': 'Download CSV',
      //group-table-action-duplicate
      'group-table-action-duplicate': 'Duplicate',
      //group-table-action-edit
      'group-table-action-edit': 'Edit',
      //group-table-action-delete
      'group-table-action-delete': 'Delete',
      //group-table-action-answers
      'group-table-action-answers': 'Records',
      //group-table-action-access
      'group-table-action-access': 'Access',

      //DOWNLOAD CSV MODAL
      'initial-date': 'Start Date',
      'final-date': 'Final Date',
      'generate-csv': 'Generate',

      //GROUPS PAGE
      //group-char-min
      'group-char-min': 'The value must contain at least 4 characters.',
      //group-char-max
      'group-char-max': 'The value must contain a maximum of 20 characters.',
      //group-char-required
      'group-char-required': 'Please fill in the field correctly. The field must have between 4-20 characters.',
      //group-page-view
      'group-page-view': 'View Groups',
      //group-page-header
      'group-page-header': 'GROUP',
      //group-page-title
      'group-page-title': 'TITLE',
      //group-page-manager
      'group-page-manager': 'MANAGER',
      //group-page-button
      'group-page-button': 'SAVE', //create??
      //group-page-edit
      'group-page-edit': 'EDIT GROUP',
      //group-page-edit-title
      'group-page-edit-title': 'Title',
      //group-page-edit-manager
      'group-page-edit-manager': 'Manager',


      //PROJECTS PAGE
      //projects-page-view
      'projects-page-view': 'VIEW PROJECTS',
      //projects-page-header
      'projects-page-header': 'PROJECT',
      //projects-page-edit
      'projects-page-edit': 'EDIT PROJECT',

      //PROJECTS EDIT PAGE
      //projects-edit-title
      'projects-edit-title': 'Title',
      //projects-edit-description
      'projects-edit-description': 'Description',
      //projects-edit-manager
      'projects-edit-manager': 'Manager',

      //PROJECTS TABLE ITEMS
      //projects-table-title
      'projects-table-title': 'Title',
      //projects-table-description
      'projects-table-description': 'Description',
      //projects-table-placeholder
      'projects-table-placeholder': 'ex: Study project',
      //projects-table-status
      'projects-table-status': 'Status',
      //projects-table-active
      'projects-table-active': 'Active',
      //projects-table-manager
      'projects-table-manager': 'Manager',
      //projects-table-owner-email
      'projects-table-email-placeholder': 'ex: youre-mail@email.com',
      //projects-table-save
      'projects-table-save': 'SAVE',

      //PROJECT FORMS PAGE
      //projects-forms-warning
      'projects-forms-warning': 'This project does not have any records. 😢',
      //projects-forms-text
      'projects-forms-text': 'TEXT',
      //projects-forms-label
      'projects-forms-label': 'LABEL',
      //projects-forms-number
      'projects-forms-number': 'NUMBER',
      //projects-forms-dropdown
      'projects-forms-dropdown': 'DROPDOWN',
      //projects-forms-checkbox
      'projects-forms-checkbox': 'CHECKBOX',
      //projects-forms-radio
      'projects-forms-radio': 'RADIO',
      //projects-forms-counter
      'projects-forms-counter': 'COUNTER',
      //projects-forms-date
      'projects-forms-date': 'DATE/HOUR',
      //projects-forms-image
      'projects-forms-image': 'PHOTO/IMAGE',
      //projects-forms-sort-button
      'projects-forms-sort-button': 'SORT FIELDS',
      //projects-forms-records-button
      'projects-forms-records-button': 'RECORDS',
      //projects-forms-records-title
      'projects-forms-records-title': 'Title',
      //projects-forms-records-description
      'projects-forms-records-description': 'Description',
      //projects-forms-records-type
      'projects-forms-records-type': 'Type',
      //projects-forms-records-manager
      'projects-forms-records-manager': 'Manager',
      //projects-forms-records-order
      'projects-forms-records-order': 'Order',
      //projects-forms-records-actions
      'projects-forms-records-actions': 'Actions',

      //PROJECT-RECORDS-TABLE
      //project-records-saved
      'project-records-saved': 'SAVED RECORDS',
      //project-records-responsible
      'project-records-responsible': 'Manager',
      //project-records-latitude
      'project-records-latitude': 'Latitude',
      //project-records-longitude
      'project-records-longitude': 'Longitude',
      //project-records-date
      'project-records-date': 'Date/Hour',
      //project-records-actions
      'project-records-actions': 'Actions',
      //project-records-answers
      'project-records-answers': 'Answers',
      //project-records-error
      'project-records-error': 'There are no records saved. 😢',
      //project-records-answers-title
      'project-records-answers-title': 'ANSWERS',

      //GENERAL-ERRORS
      //invalid-email
      'invalid-email': 'Invalid e-mail!',
      //empty-field
      'empty-field': 'Please, fill in the field!',
      //forgot-password-warning
      'forgot-password-warning': 'Please, contact your supervisor!',
      //wrong-email-password
      'wrong-email-password': 'Incorrect e-mail and/or password!',

      //GENERAL-INFOS
      //options-field-requisition
      'options-field-requisition': 'Please, fill in the field with at least one option.',
      //options-field-empty
      'options-field-empty': 'Please, insert a value in the Options field.',
      //insert-value-placeholder
      'insert-value-placeholder': 'Insert a value',
      //write-text-placeholder
      'write-text-placeholder': 'Write the text here...',
      //title-placeholder
      'title-placeholder': 'ex: Title',
      //button-project-field-name
      'button-project-field-name': 'Field Name',
      //button-project-field-description
      'button-project-field-description': 'Description',
      //button-project-field-manager
      'button-project-field-manager': 'Manager',
      //button-project-field-options
      'button-project-field-options': 'Options',
      //obligatory-field
      'obligatory-field': 'Obligatory field',
      //go-back-button
      'go-back-button': 'Go Back',
      //loading-warning
      'loading': 'Loading...',
      //delete-option-contract
      'delete-option-contract': 'Do you really want to delete the Group?',
      //delete-verification-contract
      'delete-verification-contract': 'When confirmed, the group "{{contractNumber}}" will be deleted.',
      //delete-option-project
      'delete-option-project': 'Do you really want to delete the Project?',
      //delete-verification-project
      'delete-verification-project': 'When confirmed, the project "{{projectRowName}}" will be deleted.',
      //delete-option-field
      'delete-option-field': 'Do you really want to delete the Field?',
      //delete-verification-field
      'delete-verification-field': 'When confirmed, the field "{{fieldRowTitle}}" will be deleted.',
      //delete-option-field-option
      'delete-option-field-option': 'Do you really want to delete the Field Option?',
      //delete-verification-field-option
      'delete-verification-field-option': 'When confirmed, the option "{{fieldOptionIdToDeleteTitle}}" will be deleted.',
      //field-delete-button
      'field-delete-button': 'DELETE',
      //field-cancel-button
      'field-cancel-button': 'CANCEL',
      //image-button-return
      'image-button-return': 'RETURN',
      //image-button-next
      'image-button-next': 'NEXT',
      //drag-and-drop-alert
      'drag-and-drop-alert': 'Please, select a CSV file.',
      //drag-and-drop-selected
      'drag-and-drop-selected': 'File selected! 🚀',
      //drag-and-drop-manual
      'drag-and-drop-manual': 'Drag and drop a CSV file or click to select one manually.',
      //new-field-title-header
      'new-field-title': 'NEW FIELD',
      //new-field-dropdown-header
      'new-field-dropdown': 'NEW DROPDOWN',
      //new-field-checkbox-header
      'new-field-checkbox': 'NEW CHECKBOX',
      //new-field-radio-header
      'new-field-radio': 'NEW RADIO',
      //new-field-counter-header
      'new-field-counter': 'NEW COUNTER',
      //new-field-image-header
      'new-field-image': 'NEW IMAGE',
      //sort-fields-button
      'sort-fields-button': 'SORT FIELDS',
      //sidebar-group-button
      'sidebar-group-button': 'Groups',

      //HEADERS-NEW-FIELDS
      //new-field-title
      'new-field-header': 'NEW FIELD',
      //new-checkbox-header
      'new-checkbox-header': 'NEW CHECKBOX',
      //new-radio-header
      'new-radio-header': 'NEW RADIO',
      //new-dropdown-header
      'new-dropdown-header': 'NEW DROPDOWN',
      //new-counter-header
      'new-counter-header': 'NEW COUNTER',
      //new-image-header
      'new-image-header': 'NEW IMAGE',

      //FIELDS-TEXTS
      //field-name
      'field-name': 'Field Name',
      //field-name-placeholder
      'field-name-placeholder': 'ex: Title',
      //field-description
      'field-description': 'Field Description',
      //field-description-placeholder
      'field-description-placeholder': 'ex: Write the text...',
      //field-manager
      'field-manager': 'Manager',
      //field-option
      'field-option': 'Option',
      //field-option-placeholder
      'field-option-placeholder': 'Insert a value',
      //field-update-button
      'field-update-button': 'UPDATE',
      //field-csv-error
      'field-csv-error': 'ERROR LOADING CSV',
      //csv-limit-field-options
      'csv-limit-field-options': 'Exceeded number of field options - MAX: 50 fields',

      //PROJECT-FIELDS
      //project-fields-title
      'project-fields-title': 'Title',
      //project-fields-description
      'project-fields-description': 'Description',
      //project-fields-type
      'project-fields-type': 'Type',
      //project-fields-manager
      'project-fields-manager': 'Manager',
      //project-fields-order
      'project-fields-order': 'Order',
      //project-fields-actions
      'project-fields-actions': 'Actions',

      //PROJECT-FIELDS-IDS
      //project-fields-id-title
      'project-fields-id-checkbox': 'Checkbox',
      //project-fields-id-text
      'project-fields-id-text': 'Text',
      //project-fields-id-dropdown
      'project-fields-id-dropdown': 'Dropdown',
      //project-fields-id-radio
      'project-fields-id-radio': 'Radio',
      //project-fields-id-image
      'project-fields-id-image': 'Image',
      //project-fields-id-counter
      'project-fields-id-counter': 'Counter',
      //project-fields-id-date
      'project-fields-id-date': 'Date/Hour',
      //project-fields-id-edit
      'project-fields-id-edit': 'Edit',
      //project-fields-id-delete
      'project-fields-id-delete': 'Delete',
      //project-fields-warning
      'project-fields-warning': 'This project does not have any fields. 😢',

      //CounterFieldSchema
      //counter-field-max
      'counter-field-max': 'The value must contain a maximum of 100 characters.',
      //counter-field-min
      'counter-field-min': 'The value must contain at least 4 characters.',
      //counter-field-required
      'counter-field-required': 'Please fill in the field correctly. The field must have between 4-100 characters.',

    }
  },

  ptBr: {
    translation: {
      //PÁGINA DE LOGIN
      //header
      'login-header': 'Bem-vindo!',
      //login CTA
      'login-cta': 'Faça o login para acessar nossa plataforma!',
      //login question
      'login-question': 'Ainda não possui acesso a nossa plataforma?',
      //login plans CTA
      'login-plans-cta': 'Clique no botão abaixo para ver nossos planos:',
      //login button
      'login-button-plans': 'VER PLANOS',
      //login e-mail field
      'login-email': 'e-mail',
      //login e-mail password
      'login-password': 'senha',
      //login button access
      'login-button-access': 'ENTRAR',
      //login button forgot password
      'login-button-forgot-password': 'Esqueceu sua senha?',

      //HEADER DE GRUPOS
      //group-welcome
      'group-welcome': 'Bem-vindo',
      //group-intro
      'group-intro': 'Você está logado como',
      //group-admin
      'group-admin': 'Administrador!',
      //group-user
      'group-user': 'Usuário!',
      //group-header
      'group-header': 'GRUPOS',
      //group-button
      'group-button': 'NOVO GRUPO',

      //GRUPOS LISTA
      //group-list-header
      'group-list-header': 'Visualizar Grupos',
      //group-list-title
      'group-list-intro': 'PROJETOS',
      //group-list-button
      'group-list-button': 'NOVO PROJETO',
      //group-searchbar
      'group-searchbar': 'Pesquise aqui...',
      //group-no-projects
      'group-no-projects': 'Esse grupo não possui nenhum projeto vinculado! 😢',

      //GRUPOS ITENS DA TABELA
      //group-table-title
      'group-table-title': 'TÍTULO',
      //group-table-description
      'group-table-description': 'DESCRIÇÃO',
      //group-table-manager
      'group-table-manager': 'RESPONSÁVEL',
      //group-table-actions
      'group-table-actions': 'AÇÕES',
      //group-table-action-download
      'group-table-action-download': 'Download CSV',
      //group-table-action-duplicate
      'group-table-action-duplicate': 'Duplicar',
      //group-table-action-edit
      'group-table-action-edit': 'Editar',
      //group-table-action-delete
      'group-table-action-delete': 'Deletar',
      //group-table-action-answers
      'group-table-action-answers': 'Registros',
      //group-table-action-access
      'group-table-action-access': 'Acessar',

      //DOWNLOAD CSV MODAL
      'initial-date': 'Data Início',
      'final-date': 'Data Final',
      'generate-csv': 'Gerar',

      //GRUPOS PÁGINA
      //group-char-min
      'group-char-min': 'O valor deve conter no mínimo 4 caracteres.',
      //group-char-max
      'group-char-max': 'O valor deve conter no máximo 20 caracteres.',
      //group-char-required
      'group-char-required': 'Por favor, preencher o campo corretamente. O campo deve ter entre 4-20 caracteres.',
      //group-page-view
      'group-page-view': 'Visualizar Grupos',
      //group-page-header
      'group-page-header': 'GRUPO',
      //group-page-title
      'group-page-title': 'TÍTULO',
      //group-page-manager
      'group-page-manager': 'RESPONSÁVEL',
      //group-page-button
      'group-page-button': 'SALVAR', //criar??
      //group-page-edit
      'group-page-edit': 'EDITAR GRUPO',
      //group-page-edit-title
      'group-page-edit-title': 'Título',
      //group-page-edit-manager
      'group-page-edit-manager': 'Responsável',

      //PÁGINA DE PROJETOS
      //projects-page-view
      'projects-page-view': 'VER PROJETOS',
      //projects-page-header
      'projects-page-header': 'PROJETO',
      //projects-page-edit
      'projects-page-edit': 'EDITAR PROJETO',

      //PROJECTS EDIT PAGE
      //projects-edit-title
      'projects-edit-title': 'Título',
      //projects-edit-description
      'projects-edit-description': 'Descrição',
      //projects-edit-manager
      'projects-edit-manager': 'Responsável',

      //ITENS DA TABELA DE PROJETOS
      //projects-table-title
      'projects-table-title': 'Título',
      //projects-table-description
      'projects-table-description': 'Descrição',
      //projects-table-placeholder
      'projects-table-placeholder': 'ex: Projeto de estudos',
      //projects-table-status
      'projects-table-status': 'STATUS',
      //projects-table-active
      'projects-table-active': 'Ativo',
      //projects-table-manager
      'projects-table-manager': 'Responsável',
      //projects-table-owner-email
      'projects-table-email-placeholder': 'ex: seue-mail@email.com',
      //projects-table-save
      'projects-table-save': 'SALVAR',

      //PÁGINA DE FORMULÁRIOS DE PROJETOS
      //projects-forms-warning
      'projects-forms-warning': 'Esse projeto não possui nenhum registro. 😢',
      //projects-forms-text
      'projects-forms-text': 'TEXTO',
      //projects-forms-label
      'projects-forms-label': 'LABEL',
      //projects-forms-number
      'projects-forms-number': 'NUMÉRICO',
      //projects-forms-dropdown
      'projects-forms-dropdown': 'DROPDOWN',
      //projects-forms-checkbox
      'projects-forms-checkbox': 'CHECKBOX',
      //projects-forms-radio
      'projects-forms-radio': 'RADIO',
      //projects-forms-counter
      'projects-forms-counter': 'CONTADOR',
      //projects-forms-date
      'projects-forms-date': 'DATA/HORA',
      //projects-forms-image
      'projects-forms-image': 'FOTO/IMAGEM',
      //projects-forms-sort-button
      'projects-forms-sort-button': 'ORDENAR CAMPOS',
      //projects-forms-records-button
      'projects-forms-records-button': 'REGISTROS',
      //projects-forms-records-title
      'projects-forms-records-title': 'Título',
      //projects-forms-records-description
      'projects-forms-records-description': 'Descrição',
      //projects-forms-records-type
      'projects-forms-records-type': 'Tipo',
      //projects-forms-records-manager
      'projects-forms-records-manager': 'Responsável',
      //projects-forms-records-order
      'projects-forms-records-order': 'Ordem',
      //projects-forms-records-actions
      'projects-forms-records-actions': 'Ações',


      //PROJECT-RECORDS-TABLE
      //project-records-saved
      'project-records-saved': 'REGISTROS SALVOS',
      //project-records-responsible
      'project-records-responsible': 'Responsável',
      //project-records-latitude
      'project-records-latitude': 'Latitude',
      //project-records-longitude
      'project-records-longitude': 'Longitude',
      //project-records-date
      'project-records-date': 'Data/Hora',
      //project-records-actions
      'project-records-actions': 'Ações',
      //project-records-answers
      'project-records-answers': 'Respostas',
      //project-records-error
      'project-records-error': 'Esse projeto não possui nenhum registro salvo! 😢',
      //project-records-answers-title
      'project-records-answers-title': 'RESPOSTAS',


      //GENERAL-ERRORS
      //invalid-email
      'invalid-email': 'E-mail inválido!',
      //empty-field
      'empty-field': 'Por favor, preencha o campo!',
      //forgot-password-warning
      'forgot-password-warning': 'Por favor, entre em contato com seu supervisor!',
      //wrong-email-password
      'wrong-email-password': 'E-mail e/ou senha incorretos!',

      //GENERAL-INFOS
      //options-field-requisition
      'options-field-requisition': 'Por favor, preencha o campo com pelo menos uma opção.',
      //options-field-empty
      'options-field-empty': 'Por favor, insira um valor no campo de Opções.',
      //insert-value-placeholder
      'insert-value-placeholder': 'Insira um valor',
      //write-text-placeholder
      'write-text-placeholder': 'Escreva o texto aqui...',
      //title-placeholder
      'title-placeholder': 'ex: Título',
      //button-project-field-name
      'button-project-field-name': 'Nome do Campo',
      //button-project-field-description
      'button-project-field-description': 'Descrição',
      //button-project-field-manager
      'button-project-field-manager': 'Responsável',
      //button-project-field-options
      'button-project-field-options': 'Opções',
      //obligatory-field
      'obligatory-field': 'Campo obrigatório',
      //go-back-button
      'go-back-button': 'Voltar',
      //loading-warning
      'loading': 'Carregando...',
      //delete-option-project
      'delete-option-contract': 'Quer mesmo excluir o Grupo?',
      //delete-verification-contract
      'delete-verification-contract': 'Ao confirmar, o grupo "{{contractNumber}}" será deletado.',
      //delete-option-project
      'delete-option-project': 'Quer mesmo excluir o Projeto?',
      //delete-verification-project
      'delete-verification-project': 'Ao confirmar, o projeto "{{projectRowName}}" será deletado.',
      //delete-option-field
      'delete-option-field': 'Quer mesmo excluir o Campo?',
      //delete-verification-field
      'delete-verification-field': 'Ao confirmar, o campo "{{fieldRowTitle}}" será deletado.',
      //delete-option-field-option
      'delete-option-field-option': 'Quer mesmo excluir a Opção do Campo?',
      //delete-verification-field-option
      'delete-verification-field-option': 'Ao confirmar, a opção "{{fieldOptionIdToDeleteTitle}}" será deletada.',
      //field-delete-button
      'field-delete-button': 'DELETAR',
      //field-cancel-button
      'field-cancel-button': 'CANCELAR',
      //image-button-return
      'image-button-return': 'VOLTAR',
      //image-button-next
      'image-button-next': 'PRÓXIMO',
      //drag-and-drop-alert
      'drag-and-drop-alert': 'Por favor, selecione um arquivo CSV.',
      //drag-and-drop-selected
      'drag-and-drop-selected': 'Arquivo selecionado! 🚀',
      //drag-and-drop-manual
      'drag-and-drop-manual': 'Arraste e solte um arquivo CSV ou clique para selecionar um manualmente.',
      //new-field-title-header
      'new-field-title': 'NOVO CAMPO',
      //new-field-dropdown-header
      'new-field-dropdown': 'NOVO DROPDOWN',
      //new-field-checkbox-header
      'new-field-checkbox': 'NOVO CHECKBOX',
      //new-field-radio-header
      'new-field-radio': 'NOVO RADIO',
      //new-field-counter-header
      'new-field-counter': 'NOVO CONTADOR',
      //new-field-image-header
      'new-field-image': 'NOVA IMAGEM',
      //sort-fields-button
      'sort-fields-button': 'ORDENAR CAMPOS',
      //sidebar-group-button
      'sidebar-group-button': 'Grupos',

      //HEADERS-NEW-FIELDS
      //new-field-title
      'new-field-header': 'NOVO CAMPO',
      //new-checkbox-header
      'new-checkbox-header': 'NOVO CHECKBOX',
      //new-radio-header
      'new-radio-header': 'NOVO RADIO',
      //new-dropdown-header
      'new-dropdown-header': 'NOVO DROPDOWN',
      //new-counter-header
      'new-counter-header': 'NOVO CONTADOR',
      //new-image-header
      'new-image-header': 'NOVA IMAGEM',

      //FIELDS-TEXTS
      //field-name
      'field-name': 'Nome do Campo',
      //field-name-placeholder
      'field-name-placeholder': 'ex: Título',
      //field-description
      'field-description': 'Descrição do Campo',
      //field-description-placeholder
      'field-description-placeholder': 'ex: Escreva o texto...',
      //field-manager
      'field-manager': 'Responsável',
      //field-option
      'field-option': 'Opção',
      //field-option-placeholder
      'field-option-placeholder': 'Insira um valor',
      //field-update-button
      'field-update-button': 'ATUALIZAR',
      //field-csv-error
      'field-csv-error': 'ERRO AO CARREGAR CSV',
      //csv-limit-field-options
      'csv-limit-field-options': 'Quantidade de opções de campo excedida - MAX: 50 campos',

      //PROJECT-FIELDS
      //project-fields-title
      'project-fields-title': 'Título',
      //project-fields-description
      'project-fields-description': 'Descrição',
      //project-fields-type
      'project-fields-type': 'Tipo',
      //project-fields-manager
      'project-fields-manager': 'Responsável',
      //project-fields-order
      'project-fields-order': 'Ordem',
      //project-fields-actions
      'project-fields-actions': 'Ações',

      //PROJECT-FIELDS-IDS
      //project-fields-id-title
      'project-fields-id-checkbox': 'Checkbox',
      //project-fields-id-text
      'project-fields-id-text': 'Texto',
      //project-fields-id-dropdown
      'project-fields-id-dropdown': 'Dropdown',
      //project-fields-id-radio
      'project-fields-id-radio': 'Radio',
      //project-fields-id-image
      'project-fields-id-image': 'Imagem',
      //project-fields-id-counter
      'project-fields-id-counter': 'Contador',
      //project-fields-id-date
      'project-fields-id-date': 'Data/Hora',
      //project-fields-id-edit
      'project-fields-id-edit': 'Editar',
      //project-fields-id-delete
      'project-fields-id-delete': 'Deletar',
      //project-fields-warning
      'project-fields-warning': 'Esse projeto não possui nenhum campo. 😢',

      //CounterFieldSchema
      //counter-field-max
      'counter-field-max': 'O valor deve conter no máximo 100 caracteres.',
      //counter-field-min
      'counter-field-min': 'O valor deve conter no mínimo 4 caracteres.',
      //counter-field-required
      'counter-field-required': 'Por favor, preencher o campo corretamente. O campo deve ter entre 4-100 caracteres.',
    },
  },
  es: {
    translation: {
      //PÁGINA DE LOGIN
      //header
      'login-header': 'Bienvenido!',
      //login CTA
      'login-cta': 'Inicia sesión para acceder a nuestra plataforma!',
      //login question
      'login-question': '¿No tienes una cuenta?',
      //login plans CTA
      'login-plans-cta': 'Haz clic en el botón de abajo para ver nuestros planes:',
      //login button
      'login-button-plans': 'VER PLANES',
      //login e-mail field
      'login-email': 'correo electrónico',
      //login e-mail password
      'login-password': 'contraseña',
      //login button access
      'login-button-access': 'ENTRAR',
      //login button forgot password
      'login-button-forgot-password': '¿Olvidaste tu contraseña?',

      //HEADER DE GRUPOS
      //group-welcome
      'group-welcome': 'Bienvenido',
      //group-intro
      'group-intro': '¡Has iniciado sesión como',
      //group-admin
      'group-admin': 'Administrador!',
      //group-user
      'group-user': 'Usuario!',
      //group-header
      'group-header': 'GRUPOS',
      //group-button
      'group-button': 'NUEVO GRUPO',

      //GRUPOS LISTA
      //group-list-header
      'group-list-header': 'Ver Grupos',
      //group-list-title
      'group-list-intro': 'PROYECTOS',
      //group-list-button
      'group-list-button': 'NUEVO PROYECTO',
      //group-searchbar
      'group-searchbar': 'Buscar aquí...',
      //group-no-projects
      'group-no-projects': '¡Este grupo no tiene ningún proyecto vinculado! 😢',

      //GRUPOS ITENS DA TABELA
      //group-table-title
      'group-table-title': 'TÍTULO',
      //group-table-description
      'group-table-description': 'DESCRIPCIÓN',
      //group-table-manager
      'group-table-manager': 'GERENTE',
      //group-table-actions
      'group-table-actions': 'ACCIONES',
      //group-table-action-download
      'group-table-action-download': 'Descargar CSV',
      //group-table-action-duplicate
      'group-table-action-duplicate': 'Duplicar',
      //group-table-action-edit
      'group-table-action-edit': 'Editar',
      //group-table-action-delete
      'group-table-action-delete': 'Bprrar',
      //group-table-action-answers
      'group-table-action-answers': 'Registros',
      //group-table-action-access
      'group-table-action-access': 'Accessar',

      //DOWNLOAD CSV MODAL
      'initial-date': 'Fecha Inicio',
      'final-date': 'Fecha Final',
      'generate-csv': 'Generar',

      //GRUPOS PÁGINA
      //group-char-min
      'group-char-min': 'El valor debe contener al menos 4 caracteres.',
      //group-char-max
      'group-char-max': 'El valor debe contener un máximo de 20 caracteres.',
      //group-char-required
      'group-char-required': 'Por favor, complete el campo correctamente. El campo debe tener entre 4-20 caracteres.',
      //group-page-view
      'group-page-view': 'Ver Grupos',
      //group-page-header
      'group-page-header': 'GRUPO',
      //group-page-title
      'group-page-title': 'TÍTULO',
      //group-page-manager
      'group-page-manager': 'GERENTE',
      //group-page-button
      'group-page-button': 'GUARDAR',
      //group-page-edit
      'group-page-edit': 'EDITAR GRUPO',
      //group-page-edit-title
      'group-page-edit-title': 'Título',
      //group-page-edit-manager
      'group-page-edit-manager': 'Gerente',

      //PÁGINA DE PROYECTOS
      //projects-page-view
      'projects-page-view': 'VER PROYECTOS',
      //projects-page-header
      'projects-page-header': 'PROYECTO',
      //projects-page-edit
      'projects-page-edit': 'EDITAR PROYECTO',

      //PROJECTS EDIT PAGE
      //projects-edit-title
      'projects-edit-title': 'Título',
      //projects-edit-description
      'projects-edit-description': 'Descripción',
      //projects-edit-manager
      'projects-edit-manager': 'Gerente',

      //ITENS DA TABELA DE PROJETOS
      //projects-table-title
      'projects-table-title': 'Título',
      //projects-table-description
      'projects-table-description': 'Descripción',
      //projects-table-placeholder
      'projects-table-placeholder': 'ex: Proyecto de estudios',
      //projects-table-status
      'projects-table-status': 'Status',
      //projects-table-active
      'projects-table-active': 'Activo',
      //projects-table-manager
      'projects-table-manager': 'Gerente',
      //projects-table-owner-email
      'projects-table-email-placeholder': 'ex: sue-mail@e-mail.com',
      //projects-table-save
      'projects-table-save': 'GUARDAR',

      //PÁGINA DE FORMULÁRIOS DE PROJETOS
      //projects-forms-warning
      'projects-forms-warning': 'Este proyecto no tiene ningún registro. 😢',
      //projects-forms-text
      'projects-forms-text': 'TEXTO',
      //projects-forms-label
      'projects-forms-label': 'LABEL',
      //projects-forms-number
      'projects-forms-number': 'NUMÉRICO',
      //projects-forms-dropdown
      'projects-forms-dropdown': 'DROPDOWN',
      //projects-forms-checkbox
      'projects-forms-checkbox': 'CHECKBOX',
      //projects-forms-radio
      'projects-forms-radio': 'RADIO',
      //projects-forms-counter
      'projects-forms-counter': 'CONTADOR',
      //projects-forms-date
      'projects-forms-date': 'FECHA/HORA',
      //projects-forms-image
      'projects-forms-image': 'FOTO/IMAGEN',
      //projects-forms-sort-button
      'projects-forms-sort-button': 'ORDENAR CAMPOS',
      //projects-forms-records-button
      'projects-forms-records-button': 'REGISTROS',
      //projects-forms-records-title
      'projects-forms-records-title': 'Título',
      //projects-forms-records-description
      'projects-forms-records-description': 'Descripción',
      //projects-forms-records-type
      'projects-forms-records-type': 'Tipo',
      //projects-forms-records-manager
      'projects-forms-records-manager': 'Gerente',
      //projects-forms-records-order
      'projects-forms-records-order': 'Orden',
      //projects-forms-records-actions
      'projects-forms-records-actions': 'Acciones',

      //PROJECT-RECORDS-TABLE
      //project-records-saved
      'project-records-saved': 'REGISTROS GUARDADOS',
      //project-records-responsible
      'project-records-responsible': 'Responsable',
      //project-records-latitude
      'project-records-latitude': 'Latitud',
      //project-records-longitude
      'project-records-longitude': 'Longitud',
      //project-records-date
      'project-records-date': 'Fecha',
      //project-records-actions
      'project-records-actions': 'Acciones',
      //project-records-answers
      'project-records-answers': 'Respuestas',
      //project-records-error
      'project-records-error': '¡Este proyecto no tiene ningún registro guardado! 😢',
      //project-records-answers-title
      'project-records-answers-title': 'RESPUESTAS',

      //GENERAL-ERRORS
      //invalid-email
      'invalid-email': '¡Correo electrónico inválido!',
      //empty-field
      'empty-field': '¡Por favor, complete el campo!',
      //forgot-password-warning
      'forgot-password-warning': '¡Por favor, contacta a tu supervisor!',
      //wrong-email-password
      'wrong-email-password': '¡Correo electrónico y/o contraseña incorrectos!',

      //GENERAL-INFOS
      //options-field-requisition
      'options-field-requisition': 'Por favor, complete el campo con al menos una opción.',
      //options-field-empty
      'options-field-empty': 'Por favor, inserte un valor en el campo de Opciones.',
      //insert-value-placeholder
      'insert-value-placeholder': 'Inserte un valor',
      //write-text-placeholder
      'write-text-placeholder': 'Escribe el texto aquí...',
      //title-placeholder
      'title-placeholder': 'ex: Título',
      //button-project-field-name
      'button-project-field-name': 'Nombre del Campo',
      //button-project-field-description
      'button-project-field-description': 'Descripción',
      //button-project-field-manager
      'button-project-field-manager': 'Gerente',
      //button-project-field-options
      'button-project-field-options': 'Opciones',
      //obligatory-field
      'obligatory-field': 'Campo obligatorio',
      //go-back-button
      'go-back-button': 'Volver',
      //loading-warning
      'loading': 'Cargando...',
      //delete-option-contract
      'delete-option-contract': '¿Realmente deseas eliminar el grupo?',
      //delete-verification-contract
      'delete-verification-contract': 'Cuando se confirme, el grupo "{{contractNumber}}" será eliminado.',
      //delete-option-project
      'delete-option-project': '¿Realmente deseas eliminar el Proyecto?',
      //delete-verification-project
      'delete-verification-project': 'Cuando se confirme, el proyecto "{{projectRowName}}" será eliminado.',
      //delete-option-field
      'delete-option-field': '¿Realmente desea eliminar el campo?',
      //delete-verification-field
      'delete-verification-field':'Cuando se confirme, el campo "{{fieldRowTitle}}" se eliminará.',
      //delete-option-field-option
      'delete-option-field-option': '¿Realmente deseas eliminar la opción de campo?',
      //delete-verification-field-option
      'delete-verification-field-option': 'Cuando se confirme, la opción "{{fieldOptionIdToDeleteTitle}}" será eliminada.',
      //field-delete-button
      'field-delete-button': 'ELIMINAR',
      //field-cancel-button
      'field-cancel-button': 'CANCELAR',
      //image-button-return
      'image-button-return': 'VOLVER',
      //image-button-next
      'image-button-next': 'SIGUIENTE',
      //drag-and-drop-alert
      'drag-and-drop-alert': 'Por favor, seleccione un archivo CSV.',
      //drag-and-drop-selected
      'drag-and-drop-selected': '¡Archivo seleccionado! 🚀',
      //drag-and-drop-manual
      'drag-and-drop-manual': 'Arrastra y suelta un archivo CSV o haz clic para seleccionar uno manualmente.',
      //new-field-title-header
      'new-field-title': 'NUEVO CAMPO',
      //new-field-dropdown-header
      'new-field-dropdown': 'NUEVO DROPDOWN',
      //new-field-checkbox-header
      'new-field-checkbox': 'NUEVO CHECKBOX',
      //new-field-radio-header
      'new-field-radio': 'NUEVO RADIO',
      //new-field-counter-header
      'new-field-counter': 'NUEVO CONTADOR',
      //new-field-image-header
      'new-field-image': 'NUEVA IMAGEN',
      //sort-fields-button
      'sort-fields-button': 'ORDENAR CAMPOS',
      //sidebar-group-button
      'sidebar-group-button': 'Grupos',

      //HEADERS-NEW-FIELDS
      //new-field-title
      'new-field-header': 'NUEVO CAMPO',
      //new-checkbox-header
      'new-checkbox-header': 'NUEVO CHECKBOX',
      //new-radio-header
      'new-radio-header': 'NUEVO RADIO',
      //new-dropdown-header
      'new-dropdown-header': 'NUEVO DROPDOWN',
      //new-counter-header
      'new-counter-header': 'NUEVO CONTADOR',
      //new-image-header
      'new-image-header': 'NUEVA IMAGEN',

      //FIELDS-TEXTS
      //field-name
      'field-name': 'Nombre del Campo',
      //field-name-placeholder
      'field-name-placeholder': 'ex: Título',
      //field-description
      'field-description': 'Descripción del Campo',
      //field-description-placeholder
      'field-description-placeholder': 'ex: Escribe el texto...',
      //field-manager
      'field-manager': 'Gerente',
      //field-option
      'field-option': 'Opción',
      //field-option-placeholder
      'field-option-placeholder': 'Inserte un valor',
      //field-update-button
      'field-update-button': 'ACTUALIZAR',
      //field-csv-error
      'field-csv-error': 'ERROR AL CARGAR CSV',
      //csv-limit-field-options
      'csv-limit-field-options': 'Número excedido de opciones de campo - MÁXIMO: 50 campos',

      //PROJECT-FIELDS
      //project-fields-title
      'project-fields-title': 'Título',
      //project-fields-description
      'project-fields-description': 'Descripción',
      //project-fields-type
      'project-fields-type': 'Tipo',
      //project-fields-manager
      'project-fields-manager': 'Gerente',
      //project-fields-order
      'project-fields-order': 'Orden',
      //project-fields-actions
      'project-fields-actions': 'Acciones',

      //PROJECT-FIELDS-IDS
      //project-fields-id-title
      'project-fields-id-checkbox': 'Checkbox',
      //project-fields-id-text
      'project-fields-id-text': 'Texto',
      //project-fields-id-dropdown
      'project-fields-id-dropdown': 'Dropdown',
      //project-fields-id-radio
      'project-fields-id-radio': 'Radio',
      //project-fields-id-image
      'project-fields-id-image': 'Imagen',
      //project-fields-id-counter
      'project-fields-id-counter': 'Contador',
      //project-fields-id-date
      'project-fields-id-date': 'Fecha/Hora',
      //project-fields-id-edit
      'project-fields-id-edit': 'Editar',
      //project-fields-id-delete
      'project-fields-id-delete': 'Eliminar',
      //project-fields-warning
      'project-fields-warning': 'Este proyecto no tiene ningún campo. 😢',

      //CounterFieldSchema
      //counter-field-max
      'counter-field-max': 'El valor debe contener un máximo de 100 caracteres.',
      //counter-field-min
      'counter-field-min': 'El valor debe contener al menos 4 caracteres.',
      //counter-field-required
      'counter-field-required': 'Por favor, complete el campo correctamente. El campo debe tener entre 4-100 caracteres.',
    },
  },
};
